import React from "react";
import { ChatPage } from "./pages/chat/chat.page";
import { MocksPage } from "./pages/mocks/mocks.page";
import { usePushNotification } from "./hooks/use-push-notification";

const App = () => {
  usePushNotification();
  const isMocks = window.location.pathname === "/mocks";
  return isMocks ? <MocksPage /> : <ChatPage />;
}

export default App;
